import type { Messages } from "./en";

export const gu: Messages = {
  app: {
    name: "સ્માર્ટ ક્રોપ પ્રોટેક્ટ",
    tagline: "તમારા ખેતરની આગાહી",
    offline: "તમે ઑફલાઇન છો. સાચવેલો ડેટા બતાવીએ છીએ.",
    updated: (t) => `${t} અપડેટ થયું`,
    staleData: "નવો ડેટા ન મળ્યો. છેલ્લી સાચવેલી આગાહી બતાવીએ છીએ.",
    loading: "લોડ થાય છે…",
    retry: "ફરી પ્રયાસ કરો",
    error: "કંઈક ખોટું થયું.",
    readAloud: "વાંચીને સંભળાવો",
    voice: "અવાજથી ચલાવો",
    listening: "સાંભળીએ છીએ… બોલો: હવામાન, સ્કેન, પૈસા, યોજના અથવા હોમ",
    notHeard: "અવાજ ન સંભળાયો. ફરી બોલો.",
    voiceUnsupported: "આ બ્રાઉઝરમાં અવાજથી ચલાવવાની સુવિધા નથી.",
    speechUnsupported: "આ ફોનમાં વાંચીને સંભળાવવાની સુવિધા નથી.",
    change: "બદલો",
    save: "સાચવો",
    cancel: "રદ કરો",
    close: "બંધ કરો",
    next: "આગળ",
    back: "પાછળ",
    done: "થઈ ગયું",
    seeAll: "બધું જુઓ",
    viewTable: "કોષ્ટકમાં જુઓ",
    viewChart: "ચાર્ટમાં જુઓ",
    source: "સ્રોત",
    disclaimer:
      "આ સામાન્ય માર્ગદર્શન છે. દવા અને માત્રા માટે ઉત્પાદનનું લેબલ અને તમારા ખેતીવાડી અધિકારી અથવા કૃષિ વિજ્ઞાન કેન્દ્રની સલાહ અનુસરો.",
  },
  nav: {
    today: "આજે",
    field: "ખેતર",
    scan: "સ્કેન",
    money: "પૈસા",
    plan: "યોજના",
    learn: "માહિતી",
    ai: "AI કેવી રીતે કામ કરે છે",
    settings: "સેટિંગ્સ",
  },
  greet: { morning: "સુપ્રભાત", afternoon: "નમસ્કાર", evening: "શુભ સાંજ" },
  units: {
    mm: "મિમી",
    kmh: "કિમી/કલાક",
    c: "°C",
    kgha: "કિગ્રા/હેક્ટર",
    tha: "ટન/હેક્ટર",
    qacre: "ક્વિન્ટલ/એકર",
    acres: "એકર",
    perQuintal: "પ્રતિ ક્વિન્ટલ",
    perKg: "પ્રતિ કિલો",
    days: (n) => `${n} દિવસ`,
    hours: (n) => `${n} કલાક`,
  },
  level: {
    good: "સારું",
    marginal: "ઠીકઠાક",
    poor: "યોગ્ય નથી",
    none: "નથી",
    low: "ઓછું",
    moderate: "મધ્યમ",
    high: "વધારે",
    warning: "ચેતવણી",
    serious: "ગંભીર",
    critical: "અતિ ગંભીર",
  },
  stage: {
    presowing: "હજુ વાવણી નથી થઈ",
    initial: "ઉગાવો અને સ્થાપના",
    development: "વૃદ્ધિ",
    mid: "ફૂલ અને દાણા/ફળ ભરાવો",
    late: "પાકવાનો સમય",
    harvest: "કાપણી માટે તૈયાર",
    day: (n) => `${n}મો દિવસ`,
    sowsIn: (n) => `${n} દિવસમાં વાવણી`,
    harvestIn: (n) => `આશરે ${n} દિવસમાં કાપણી`,
    harvestOn: (d) => `અંદાજિત કાપણી ${d}`,
  },
  onboarding: {
    welcomeTitle: "વિશ્વાસથી ખેતી કરો",
    welcomeBody:
      "તમારા પોતાના ખેતર માટે હવામાન, પાણી, જીવાત-રોગ જોખમ અને ભાવની આગાહી. સરકારી પાક આંકડા અને ઉપગ્રહ હવામાન પર આધારિત. ઇન્ટરનેટ વગર પણ ચાલે છે, અને તમારો ડેટા તમારા ફોનમાં જ રહે છે.",
    start: "શરૂ કરો",
    languageTitle: "તમારી ભાષા પસંદ કરો",
    locationTitle: "તમારું ખેતર ક્યાં છે?",
    locationBody: "તમારું સ્થાન ફક્ત હવામાન અને જમીનની માહિતી લાવવા માટે વપરાય છે. તે આ ફોનમાં જ રહે છે.",
    useGps: "મારું સ્થાન શોધો",
    locating: "તમારું સ્થાન શોધીએ છીએ…",
    orChoose: "અથવા તમારો જિલ્લો પસંદ કરો",
    state: "રાજ્ય",
    district: "જિલ્લો",
    gpsFailed: "સ્થાન ન મળ્યું. કૃપા કરી તમારો જિલ્લો પસંદ કરો.",
    outsideIndia: "આ એપ ભારત માટે છે. કૃપા કરી જિલ્લો પસંદ કરો.",
    cropTitle: "તમે શું ઉગાડો છો?",
    season: "ઋતુ",
    sowingDate: "વાવણીની તારીખ",
    fieldTitle: "તમારા ખેતર વિશે",
    area: "ખેતરનું કદ",
    irrigation: "પાણીનો સ્રોત",
    ready: "બધું તૈયાર છે",
    readyBody: "તમારા ખેતરનું ડેશબોર્ડ તૈયાર છે.",
  },
  irrigationMethod: {
    rainfed: "ફક્ત વરસાદ",
    flood: "નહેર / ક્યારા પિયત",
    sprinkler: "ફુવારા (સ્પ્રિંકલર)",
    drip: "ટપક (ડ્રિપ)",
  },
  today: {
    title: "આજે",
    irrigation: "પિયત",
    spraying: "છંટકાવ",
    pestRisk: "જીવાત અને રોગનું જોખમ",
    cropStage: "પાકની અવસ્થા",
    alerts: "હવામાન ચેતવણી",
    noAlerts: "આ અઠવાડિયે કોઈ હવામાન ચેતવણી નથી.",
    week: "આગામી 7 દિવસ",
    outlook: "ઉત્પાદન અને ભાવનો અંદાજ",
    tasks: "આગળના કામ",
    tip: "આજની સલાહ",
    setLocation: "આગાહી માટે તમારા ખેતરનું સ્થાન પસંદ કરો.",
  },
  irrigate: {
    now: (mm) => `આજે પિયત આપો: આશરે ${mm} મિમી`,
    by: (d) => `${d} સુધીમાં પિયત આપો`,
    byAmount: (mm, l) => `આશરે ${mm} મિમી (એકરે ${l} લિટર)`,
    hold: (mm, d) => `રાહ જુઓ: ${d} દિવસમાં ${mm} મિમી વરસાદની શક્યતા`,
    ok: "હમણાં પિયતની જરૂર નથી",
    okSub: (p) => `મૂળ વિસ્તાર ${100 - p}% ભરેલો છે`,
    rainfedStress: (d) => `${d} થી સૂકા તણાવની શક્યતા`,
    rainfedSub: "મલ્ચિંગથી ભેજ બચાવો; શક્ય હોય તો રક્ષણાત્મક પિયત આપો.",
    notSown: "ખેતરમાં હજુ વાવણી નથી થઈ",
    harvest: "પાક તૈયાર છે; પિયત બંધ કરો",
    riceFlooded: "ખેતરમાં 2–5 સેમી પાણી રાખો",
    riceAwd: (n) => `આશરે 5 સેમી પાણી ભરો: ${n} દિવસથી સારો વરસાદ નથી`,
    riceAwdSub: "વારાફરતી ભીનું-સૂકું રાખવાથી ઉત્પાદન ઘટાડ્યા વગર આશરે 25% પાણી બચે છે.",
    riceDrain: "પાણી કાઢી નાખો: કાપણી નજીક છે",
    logged: "પિયત નોંધાયું",
    logToday: "મેં આજે પિયત આપ્યું",
  },
  spray: {
    goodNow: "હમણાં છંટકાવનો સારો સમય છે",
    window: (a, b) => `સૌથી સારો સમય: ${a}–${b}`,
    none: "2 દિવસમાં છંટકાવનો સલામત સમય નથી",
    noneSub: "વરસાદ, પવન અથવા ગરમીની શક્યતા. આગલી આગાહીની રાહ જુઓ.",
    reason: {
      "rain-now": "વરસાદ પડે છે",
      "rain-soon": "4 કલાકમાં વરસાદ",
      "wind-high": "વધુ પવન: દવા ઉડી જશે",
      "wind-calm": "બિલકુલ પવન નથી: દવા હવામાં રહે",
      hot: "ખૂબ ગરમી",
      "dry-air": "સૂકી હવા: ટીપાં ઉડી જશે",
      humid: "ખૂબ ભેજ: મોડું સુકાશે",
      dark: "અંધારું",
    },
    planner: "છંટકાવ યોજના",
    plannerSub: "આગામી 48 કલાક: વરસાદ, પવન, ગરમી અને ડેલ્ટા-T ની ચકાસણી.",
  },
  risk: {
    none: "આ અઠવાડિયે જોખમ ઓછું",
    noneSub: "હવામાન મોટા ઉપદ્રવ માટે અનુકૂળ નથી.",
    title: "જીવાત અને રોગનું જોખમ",
    sub: "કલાકવાર ભેજ, પાન ભીનાશ અને તાપમાનથી ચેપનું જોખમ.",
    peak: (d) => `${d} ના રોજ સૌથી વધુ`,
    driver: {
      wetness: "પાન લાંબો સમય ભીના",
      "warm-humid": "ગરમ અને ભેજવાળું",
      "hot-dry": "ગરમ અને સૂકું",
      "cool-humid": "ઠંડું અને ભેજવાળું",
      "rain-wind": "વરસાદ અને પવન",
      warm: "ગરમ હવામાન",
    },
  },
  alert: {
    heat: (v) => `લૂ: ${v}°C સુધી. સાંજે પિયત આપો, બપોરે છંટકાવ ન કરો.`,
    cold: (v) => `ઠંડી રાતો, ${v}°C સુધી. હળવું પિયત પાકને બચાવે છે.`,
    frost: (v) => `હિમનું જોખમ: ${v}°C. સાંજે હળવું પિયત આપો; ધરુવાડિયું ઢાંકો.`,
    "heavy-rain": (v) => `ભારે વરસાદ: એક દિવસમાં ${v} મિમી. નીકો ખોલો; ખાતર અને છંટકાવ મુલતવી રાખો.`,
    wind: (v) => `${v} કિમી/કલાક સુધી ભારે પવન. ઊંચા પાકને ટેકો આપો; છંટકાવ ન કરો.`,
    storm: () => "વાવાઝોડાની શક્યતા. વીજળી થાય ત્યારે ખુલ્લા ખેતરમાં ન રહો.",
    hail: () => "કરા પડી શકે. પાકેલો પાક કાપો અને અનાજ સુરક્ષિત રાખો.",
    "dry-spell": (v) => `${v} દિવસ સુધી ઉપયોગી વરસાદ નથી. પિયતનું આયોજન કરો અને મલ્ચિંગ કરો.`,
  },
  field: {
    title: "ખેતર",
    sub: "તમારા પાક માટે હવામાન, પાણી અને રક્ષણ.",
    forecast: "10 દિવસની આગાહી",
    temperature: "તાપમાન",
    rainfall: "વરસાદ",
    rainChance: (p) => `${p}% શક્યતા`,
    max: "મહત્તમ",
    min: "લઘુત્તમ",
    waterTitle: "જમીનમાં પાણી",
    waterSub: "તમારા મૂળ વિસ્તારનું FAO-56 જળ સંતુલન: છેલ્લા 14 દિવસ અને આગાહી.",
    depletion: "મૂળ માટે ઉપલબ્ધ પાણી",
    raw: "તણાવ શરૂ",
    taw: "ખાલી",
    irrigationTitle: "પિયત સલાહ",
    soilTitle: "તમારી જમીન",
    soilFrom: "ISRIC SoilGrids (250 મીટર) માંથી",
    soilManual: "તમે પસંદ કરેલા પ્રકારની સામાન્ય જમીન",
    texture: "બનાવટ",
    ph: "pH",
    awc: "પાણી સંગ્રહ ક્ષમતા",
    organicCarbon: "સેન્દ્રિય કાર્બન",
    phOk: "pH આ પાક માટે યોગ્ય છે",
    phLow: "આ પાક માટે ખાટી (એસિડિક): જમીન ચકાસણી પછી ચૂનો આપવાનું વિચારો",
    phHigh: "આ પાક માટે ક્ષારીય: જમીન ચકાસણી પછી સેન્દ્રિય ખાતર અથવા જીપ્સમ આપો",
    today: "આજે",
    tomorrow: "કાલે",
    wind: "પવન",
    humidity: "ભેજ",
  },
  scan: {
    title: "પાક ડૉક્ટર",
    sub: "પાનનો ફોટો લો અથવા જે દેખાય છે તે જણાવો. તપાસ તમારા ફોનમાં જ થાય છે.",
    photoTab: "ફોટો",
    symptomsTab: "લક્ષણો",
    take: "ફોટો લો અથવા પસંદ કરો",
    trySample: "પાન હાથવગું નથી? નમૂનાનો ફોટો અજમાવો:",
    tips: "એક રોગિષ્ઠ પાનને આખી ફ્રેમમાં, દિવસના પ્રકાશમાં, સ્પષ્ટ ફોટો લો.",
    analyze: "ફોટો તપાસો",
    analyzing: "તપાસ થાય છે…",
    loadingModel: "AI મોડેલ લોડ થાય છે (ફક્ત પહેલી વાર)…",
    modelUnavailable: "પાનનું AI મોડેલ હજુ ઉપલબ્ધ નથી. ફક્ત નુકસાનનો નકશો બતાવીએ છીએ.",
    results: "પરિણામ",
    likely: "સૌથી વધુ શક્યતા",
    possible: "આ પણ શક્ય",
    confidence: (p) => `${p}% વિશ્વાસ`,
    unsure: "ચોક્કસ કહી શકતા નથી. એક પાનનો નજીકથી સ્પષ્ટ ફોટો લો.",
    notLeaf: "આ પાન જેવું લાગતું નથી. એક રોગિષ્ઠ પાનને આખી ફ્રેમમાં લઈ ફરી પ્રયાસ કરો.",
    cropNotCovered:
      "ફોટો મોડેલ ડાંગર, મકાઈ, કપાસ, મગફળી, બટાકા અને ટામેટા માટે છે. આ પાક માટે 'લક્ષણો' ટેબ વધુ ભરોસાપાત્ર છે.",
    healthy: "તંદુરસ્ત દેખાય છે",
    verify:
      "ખેતરના ફોટા લેબના ફોટા કરતાં અઘરા હોય છે: છંટકાવ પહેલાં ખાતરી કરો કે નીચેનાં લક્ષણો તમારા પાન સાથે મેળ ખાય છે.",
    otherCrop: (c) => `આ ${c} લાગે છે, તમે પસંદ કરેલો પાક નહીં.`,
    severity: "પાનનો નુકસાન પામેલો ભાગ",
    severityNote: "પાનના રંગ પરથી અંદાજ. બદામી અને પીળા ભાગ દર્શાવ્યા છે.",
    whatToDo: "શું કરવું",
    signs: "કેવી રીતે ઓળખવું",
    favours: "કયા હવામાનમાં વધે",
    cultural: "ખેતરના ઉપાય",
    biological: "સેન્દ્રિય અને જૈવિક ઉપાય",
    chemical: "રાસાયણિક (લેબલ મુજબ)",
    pickSymptoms: "તમને શું દેખાય છે?",
    findCauses: "શક્ય કારણો શોધો",
    clear: "સાફ કરો",
    noMatch: "ખેતરમાં દેખાતું ઓછામાં ઓછું એક લક્ષણ પસંદ કરો.",
    matched: "મળતા લક્ષણો",
    weatherBoost: "આ અઠવાડિયાનું હવામાન તેને અનુકૂળ છે",
    saved: "ખેતર ડાયરીમાં સાચવ્યું",
    saveLog: "ખેતર ડાયરીમાં સાચવો",
    log: "ખેતર ડાયરી",
    logEmpty: "તમારા સાચવેલા સ્કેન અહીં દેખાશે અને ઇન્ટરનેટ વગર પણ મળશે.",
    privacy: "ફોટા તમારા ફોનની બહાર જતા નથી.",
  },
  symptom: {
    spots: "પાન પર ટપકાં",
    "eye-lesions": "આંખ કે હોડી જેવા ટપકાં, વચ્ચે રાખોડી",
    "concentric-rings": "નિશાન જેવા વલયવાળા ટપકાં",
    "rust-pustules": "કાટ જેવા નારંગી ભૂકીવાળા ફોલ્લા",
    powder: "પાન પર સફેદ ભૂકી",
    "water-soaked": "ઘેરા, પાણીથી ભીંજાયેલા જેવા ડાઘ",
    "white-mould-under": "પાનની નીચે સફેદ/રાખોડી ફૂગ",
    "purple-patches": "જાંબલી ધાબાં",
    "leaf-tip-dry": "પાનની ટોચ/કિનારી સુકાવી",
    yellowing: "પાન પીળા પડવા",
    mosaic: "પીળો-લીલો પંચરંગી ડાઘ",
    "leaf-curl": "પાન વળી જવા કે કોકડાઈ જવા",
    silvering: "ચાંદી જેવી રેખાઓ",
    wilting: "ભીની જમીનમાં પણ છોડ ચીમળાવો",
    stunting: "છોડનો વિકાસ અટકવો",
    "rotting-stem": "થડ કે મૂળ પાસે સડો",
    holes: "પાનમાં કાણાં કે કાપેલા પાન",
    frass: "ભૂંગળીમાં લાકડાના વહેર જેવી હગાર",
    "bored-fruit": "શીંગ, જીંડવા કે ફળમાં કાણાં",
    "dead-heart": "વચ્ચેનો પીલો સુકાવો",
    "sticky-insects": "નાની જીવાત, ચીકણા પાન",
    webbing: "ઝીણા જાળાં",
    "dry-cracked": "દાઝેલાં પાન, ફાટેલી સૂકી જમીન",
    "standing-water": "ખેતરમાં પાણી ભરાયું, મૂળ સડે",
    lodged: "છોડ જમીન પર ઢળી પડ્યા",
    weeds: "વધુ નીંદણ",
    "mouldy-grain": "ફૂગવાળા કે બગડેલા દાણા",
    trampled: "પ્રાણીઓએ કચડ્યું કે ખાધું",
  },
  kind: {
    all: "બધા",
    fungal: "ફૂગ",
    bacterial: "જીવાણુ",
    viral: "વાયરસ",
    insect: "જીવાત",
    mite: "કથીરી",
    abiotic: "હવામાન અને જમીન",
  },
  money: {
    title: "ઉત્પાદન અને પૈસા",
    sub: "જિલ્લાના ઉત્પાદનની આગાહી, બજારનું વલણ અને ટેકાના ભાવ.",
    yieldTitle: "અંદાજિત ઉત્પાદન",
    yieldSub: (d) => `${d} જિલ્લા માટે મશીન લર્નિંગ આગાહી`,
    range: (a, b) => `શક્ય શ્રેણી ${a} – ${b}`,
    vsNormal: (p) => (p >= 0 ? `તમારા જિલ્લાના સામાન્ય કરતાં ${p}% વધુ` : `તમારા જિલ્લાના સામાન્ય કરતાં ${-p}% ઓછું`),
    basedOn: (k, n) =>
      k === 0
        ? "ઋતુ પહેલાં: જિલ્લાના ઇતિહાસ અને સામાન્ય હવામાન પર આધારિત"
        : `આ ઋતુના ${n} માંથી ${k} મહિનાનું હવામાન સામેલ`,
    rainSoFar: (p) => `અત્યાર સુધીનો વરસાદ: સામાન્યના ${p}%`,
    scenarioTitle: "જો બાકીની ઋતુ રહે…",
    dry: "સૂકી",
    normal: "સામાન્ય",
    wet: "વધુ વરસાદ",
    history: "જિલ્લાનું ઉત્પાદન",
    forecastMark: "આગાહી",
    noYieldData: "આ પાક અને ઋતુના જિલ્લા આંકડા નથી, તેથી ઉત્પાદનની આગાહી નથી.",
    tomatoNote: "સરકારી જિલ્લા આંકડામાં હજુ આ પાક સામેલ નથી.",
    incomeTitle: "આવકનો અંદાજ",
    incomeSub: "ખેતરનું કદ × અંદાજિત ઉત્પાદન × ભાવ.",
    production: "અંદાજિત ઉત્પાદન",
    priceUsed: "લીધેલો ભાવ",
    grossIncome: "કુલ આવક",
    mspLabel: (s) => `ટેકાનો ભાવ ${s}`,
    marketLabel: "બજાર ભાવ (આગાહી)",
    pricesTitle: "બજાર ભાવનું વલણ",
    pricesSub: (z) => `${z} વિભાગમાં છૂટક ભાવ, 80% આગાહી શ્રેણી સાથે`,
    latest: (m) => `છેલ્લો નોંધાયેલ (${m})`,
    expected: (m) => `${m} માં અંદાજિત`,
    noPrice: "આ પાકના બજાર ભાવના આંકડા નથી. નીચે APMC ના તાજા ભાવ જુઓ.",
    retailNote: "છૂટક ભાવ બજારની દિશા બતાવે છે; APMC માં તમને મળતો ભાવ ઓછો હોય છે.",
    mandiTitle: "આજના APMC ભાવ",
    mandiSub: (d) => `એગમાર્કનેટ જથ્થાબંધ ભાવ, ${d} અપડેટ`,
    modal: "મોડલ ભાવ",
    mspTitle: "લઘુત્તમ ટેકાનો ભાવ",
    mspNone: "આ પાક માટે ટેકાનો ભાવ જાહેર નથી.",
    helpTitle: "વેચો, વીમો લો, મદદ મેળવો",
    agmarknet: "APMC ના તાજા ભાવ (એગમાર્કનેટ)",
    enam: "ઓનલાઇન વેચો (ઈ-નામ)",
    pmfby: "પાક વીમો (PMFBY)",
    kvk: "તમારું કૃષિ વિજ્ઞાન કેન્દ્ર શોધો",
    kcc: "કિસાન કૉલ સેન્ટર 1800-180-1551",
    zone: { north: "ઉત્તર", south: "દક્ષિણ", east: "પૂર્વ", west: "પશ્ચિમ", northeast: "ઉત્તર-પૂર્વ" },
  },
  plan: {
    title: "ઋતુની યોજના",
    sub: "પાકની સમયરેખા, કામ અને આવતી ઋતુના વિકલ્પો.",
    timeline: "પાકની સમયરેખા",
    sowing: "વાવણી",
    harvest: "કાપણી",
    tasksTitle: "કામોની યાદી",
    addTask: "તમારું કામ ઉમેરો",
    addPlaceholder: "જેમ કે: ઉત્તર બાજુના ખેતરમાં લીમડો છાંટો",
    add: "ઉમેરો",
    advisorTitle: "આવતી ઋતુમાં શું ઉગાડવું",
    advisorSub: (s, d) => `${d} માં ${s} માટે એકરદીઠ અંદાજિત આવકના ક્રમમાં પાક`,
    expectedYield: "અંદાજિત ઉત્પાદન",
    perAcre: "એકરદીઠ આવક",
    risk: "ખરાબ વર્ષમાં",
    noAdvisor: "પાકની સરખામણી માટે જિલ્લાના પૂરતા આંકડા નથી.",
    stageTasks: {
      initial: [
        "જ્યાં છોડ ન ઊગ્યા ત્યાં ખાલા પૂરો",
        "વાવણી પછી 20–25 દિવસે પહેલું નીંદામણ",
        "નાના છોડમાં જીવાત અને કોહવારો તપાસો",
      ],
      development: ["જમીન ચકાસણી મુજબ નાઈટ્રોજન આપો", "બીજું નીંદામણ કે આંતરખેડ", "અઠવાડિયે બે વાર જીવાત તપાસો"],
      mid: [
        "ફૂલ આવે ત્યારે પાકને સુકાવા ન દો",
        "ફૂલ અને દાણા/શીંગને જીવાતથી બચાવો",
        "ફેરોમોન ટ્રેપ અને પક્ષી બેસવાના ટેકા લગાવો",
      ],
      late: [
        "કાપણીના 10–15 દિવસ પહેલાં પિયત બંધ કરો",
        "કાપણી માટે મજૂર કે મશીન નક્કી કરો",
        "ગોડાઉન સાફ કરો; થેલીઓ તપાસો",
      ],
      presowing: ["જમીનની ચકાસણી કરાવો", "ભલામણ કરેલી જાતનું પ્રમાણિત બિયારણ ખરીદો", "પાણી નિકાલની નીકો બનાવો"],
      harvest: [
        "સંગ્રહ પહેલાં ઉત્પાદન સારી રીતે સૂકવો",
        "વેચતા પહેલાં બજાર ભાવ જુઓ",
        "પાકના અવશેષ સલામત રીતે દૂર કરો; બાળો નહીં",
      ],
    },
  },
  learn: {
    title: "માહિતી",
    sub: "જીવાત, રોગ અને પાક નુકસાનનાં અન્ય કારણો, અને તેનું વ્યવસ્થાપન.",
    search: "જીવાત અને રોગ શોધો",
    forCrop: (c) => `${c} માટેના જોખમો`,
    allCrops: "બધા પાક",
  },
  settings: {
    title: "સેટિંગ્સ",
    profile: "તમારું ખેતર",
    location: "સ્થાન",
    crop: "પાક",
    language: "ભાષા",
    theme: "દેખાવ",
    themeSystem: "ફોન મુજબ",
    themeLight: "આછો",
    themeDark: "ઘેરો",
    textSize: "અક્ષરનું કદ",
    soil: "જમીનનો પ્રકાર",
    soilAuto: "આપોઆપ (SoilGrids)",
    soilSandy: "રેતાળ",
    soilLoamy: "ગોરાડુ",
    soilClay: "ચીકણી",
    soilBlack: "કાળી કપાસની જમીન",
    privacy: "ગોપનીયતા",
    privacyBody:
      "બધું આ ફોનમાં જ રહે છે. હવામાન, જમીન અને ઉપગ્રહ ડેટા ફક્ત તમારા ખેતરના નિર્દેશાંકથી જાહેર સેવાઓમાંથી લાવવામાં આવે છે. કોઈ ખાતું નહીં, કોઈ ટ્રેકિંગ નહીં.",
    reset: "બધો ડેટા કાઢી નાખો",
    resetConfirm: "આ ફોનમાંથી ખેતરની માહિતી, કામ અને સાચવેલા સ્કેન કાઢી નાખીએ?",
    about: "વિશે",
    version: (v) => `આવૃત્તિ ${v}`,
  },
  tips: [
    "સવારે વહેલા ખેતર જુઓ, ત્યારે જીવાત સહેલાઈથી દેખાય છે.",
    "છોડના થડ પાસે પાણી આપો જેથી પાન સૂકાં રહે અને રોગ ઓછો થાય.",
    "દર ઋતુમાં પાક બદલો જેથી જીવાત અને રોગનું ચક્ર તૂટે.",
    "ઓજારો સાફ રાખો જેથી રોગ એક ખેતરમાંથી બીજામાં ન ફેલાય.",
    "પાનની નીચેની બાજુ જુઓ, ઘણી જીવાત ત્યાં છુપાય છે.",
    "સંગ્રહ પહેલાં અનાજ પૂરેપૂરું સૂકવો.",
    "શેઢા નીંદણમુક્ત રાખો, તેમાં જીવાત છુપાય છે.",
  ],
  months: ["જાન્યુ", "ફેબ્રુ", "માર્ચ", "એપ્રિ", "મે", "જૂન", "જુલા", "ઑગ", "સપ્ટે", "ઑક્ટો", "નવે", "ડિસે"],
};
